module.exports = __webpack_public_path__ + "static/media/face6b.5cd766a8.jpg";